export default __webpack_public_path__ + "static/media/flickr-icon.57659be6.svg";